import ChannelList from 'components/admin/account/channel/ChannelList.vue'
import SchoolList from 'components/admin/account/school/SchoolList.vue'
import SchoolEdit from 'components/admin/account/school/SchoolEdit.vue'
import TeacherList from 'components/admin/account/teacher/TeacherList.vue'
import TeacherEdit from 'components/admin/account/teacher/TeacherEdit.vue'
import TeacherBatchImport from 'components/admin/account/teacher/TeacherBatchImport.vue'
import StudentList from 'components/admin/account/student/StudentList.vue'
import StudentEdit from 'components/admin/account/student/StudentEdit.vue'
import StudentBatchImport from 'components/admin/account/student/StudentBatchImport.vue'

// 后台账户管理
export let admin_channel = {
  path: 'channel/list',
  component: ChannelList,
  meta: {auth: $user => $user.$$is_super},
}
export let admin_school = {
  path: 'school/list',
  component: SchoolList,
  meta: {auth: $user => !$user.$$is_teacher},
}
export let admin_school_edit = {
  path: 'school/edit',
  component: SchoolEdit,
  meta: {auth: $user => !$user.$$is_teacher},
}
export let admin_teacher = {
  path: 'teacher/list',
  component: TeacherList,
  meta: {auth: $user => !$user.$$is_teacher || $user.$$auth.admin_teacher},
}
export let admin_teacher_batch_import = {
  path: 'teacher/batch',
  component: TeacherBatchImport,
  meta: {auth: $user => !$user.$$is_teacher || $user.$$auth.admin_teacher},
}
export let admin_teacher_edit = {
  path: 'teacher/edit',
  component: TeacherEdit,
  meta: {auth: $user => !$user.$$is_teacher || $user.$$auth.admin_teacher},
}
export let admin_student = {
  path: 'student/list',
  component: StudentList,
  meta: {auth: $user => !$user.$$is_teacher || $user.$$auth.admin_student},
}
export let admin_student_batch_import = {
  path: 'student/batch',
  component: StudentBatchImport,
  // 参数没有 group_uid 时需要先创建班级，需要有 admin_group 的权限
  meta: {
    auth: ($user, query) => {
      return !$user.$$is_teacher ||
                $user.$$auth.admin_student && (query.group_uid || $user.$$auth.admin_group)
    },
  },
}
export let admin_student_edit = {
  path: 'student/edit',
  component: StudentEdit,
  meta: {auth: $user => !$user.$$is_teacher || $user.$$auth.admin_student},
}

export let admin_account_routes = [
  admin_channel,
  admin_school,
  admin_school_edit,
  admin_teacher,
  admin_teacher_edit,
  admin_teacher_batch_import,
  admin_student,
  admin_student_edit,
  admin_student_batch_import,
]

export let admin_account_map = {
  admin_channel,
  admin_school,
  admin_school_edit,
  admin_teacher,
  admin_teacher_edit,
  admin_teacher_batch_import,
  admin_student,
  admin_student_edit,
  admin_student_batch_import,
}



// WEBPACK FOOTER //
// ./src/router/routes/admin/account.js